import { RouteConfig } from "vue-router";

export const routes: Array<RouteConfig> = [
  // 首页
  {
    path: "/",
    name: "home",
    component: () => import("../views/home/index.vue"),
  },
  // 搜索结果页
  {
    path: "/search",
    name: "search",
    component: () => import("../views/search/index.vue"),
  },
  // 列表页
  {
    path: "/list",
    name: "list",
    component: () => import("../views/list/index.vue"),
  },
  // 详情页
  {
    path: "/detail",
    name: "detail",
    component: () => import("../views/detail/index.vue"),
  },
  // 意见建议
  {
    path: "/advice",
    name: "advice",
    component: () => import("../views/advice/index.vue"),
  },
];
